import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { getPrBuildData, clearCookie } from '../../../services/pr-build-service';

import style from './pr-build-button.module.less';

const PRBuildButton = () => {
  const clearButtonClick = useCallback(() => {
    clearCookie();
    window.location.href = '/';
  }, []);

  const { gitSha, sourceType } = getPrBuildData();

  return (
    <DropdownMenu closeWhenChildrenClicked={false} menuPosition='bottom-right'>
      <DropdownMenuToggler hideChevron theme='unstyled'>
        <span className={style['icon-wrapper']}>
          <FontAwesomeIcon icon={faCogs} />
        </span>
      </DropdownMenuToggler>
      <div className={style['dropdown-menu']}>
        <p>
          You are using a PR build. The git sha is <b>{gitSha}</b> and the sourceType is <b>{sourceType}</b>.
        </p>
        <Button onClick={clearButtonClick} theme='danger'>
          Leave PR Build
        </Button>
      </div>
    </DropdownMenu>
  );
};

export default PRBuildButton;
